import React from 'react';
import { useBusy, BusyOverlay } from './busy_component';
import SignupDialog from './signup_dialog';

import UserStore from '../stores/user_store';

const ROCKET = require('../assets/img/rocket_black.svg');
const MAIL = require('../assets/img/mail_black.svg');

type Props = {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  bottomText?: string;
  bottomLinkText?: string;
  onBottomPress?: () => void;
  onSuccess: () => void;
};
export default function LoginBoxes(props: Props) {
  const [email, setEmail] = React.useState('');
  const [login_code, setLoginCode] = React.useState('');
  const [is_busy, setBusy, clearBusy] = useBusy();
  const [show_code, setShowCode] = React.useState(false);
  const [show_not_member, setShowNotMember] = React.useState(false);

  function _onSendCode() {
    if (email && setBusy()) {
      UserStore.emailCode({ email }, (err) => {
        clearBusy();
        if (err === 404) {
          window.alert('User not found.  Please signup before logging in.');
        } else if (err) {
          window.alert('Failed to send code.');
        } else {
          setShowCode(true);
        }
      });
    }
  }
  function _onSignin() {
    if (email && login_code && setBusy()) {
      UserStore.loginCode({ email, login_code }, (err) => {
        if (err === 412) {
          setShowNotMember(true);
        } else if (err) {
          window.alert('Login failed, please check your code.');
        } else {
          props.onSuccess();
        }
        clearBusy();
      });
    }
  }
  function _onCodeBack() {
    setLoginCode('');
    setShowCode(false);
    setShowNotMember(false);
  }
  function _onLoginCancel() {
    setEmail('');
    setLoginCode('');
    setShowCode(false);
    setShowNotMember(false);
  }
  let content: any = null;
  if (show_not_member) {
    content = (
      <SignupDialog
        title='Not A Member'
        subtitle='You are not a member of this Organization. Please contact your
          administrator and have them invite you to this organization.'
        icon={ROCKET}
        bottomLinkText='Back to Login'
        onBottomPress={_onLoginCancel}
      />
    );
  } else if (show_code) {
    content = (
      <SignupDialog
        title={'Check your email'}
        subtitle={`We sent a verification code to ${email}`}
        placeholder='code'
        icon={MAIL}
        value={login_code}
        onChangeText={setLoginCode}
        buttonText='Verify Email'
        onPress={_onSignin}
        bottomText="Didn't receive the email?"
        bottomLinkText='Click to resend'
        onBottomPress={_onCodeBack}
      />
    );
  } else {
    content = (
      <>
        <SignupDialog
          title={props.title ?? 'Login to your account'}
          subtitle={props.subtitle ?? 'We will send you a unique code'}
          placeholder='Enter your email'
          icon={ROCKET}
          value={email}
          onChangeText={setEmail}
          buttonText={props.buttonText ?? 'Send'}
          onPress={_onSendCode}
          bottomText={props.bottomText}
          bottomLinkText={props.bottomLinkText}
          onBottomPress={props.onBottomPress}
        />
      </>
    );
  }
  return (
    <>
      {content}
      <BusyOverlay isBusy={is_busy} />
    </>
  );
}
